export default __webpack_public_path__ + "static/media/fourscreen.5ace789c.png";